<template>

  <ion-page style="">
    <ion-content style="height: 100%; overflow-y: auto;">

      <!-- Swiper Section with Captions (unchanged) -->
      <ion-item
        style=" width: 100%; display: inline-flex; background-image: url('https://aes-site-assets.pages.dev/logo-resized.png');">
        <swiper-container :slides-per-view="1" :navigation="true" :pagination="true" :autoplay="true" :speed="500"
          class="responsive-swiper" style="padding-top:20px;">
          <swiper-slide v-for="(slide, index) in slides" :key="index" style="position: relative;">
            <img class="swiper-image" :src="slide.image" :alt="'Slide ' + (index + 1)" />
            <div v-if="slide.caption" class="slide-caption">{{ slide.caption }}</div>
          </swiper-slide>
        </swiper-container>
      </ion-item>

      <!-- Tagline -->
      <ion-item lines="none">
        <div style="text-align: center; width: 100%; text-align: center;">
          <h1>Your Trusted Partner in Commercial Electrical & Low Voltage Systems</h1>
          <p style="color:#1C8AF7">
            Atlantis Electrical Systems delivers reliable, professional‑grade solutions in commercial electrical and
            low‑voltage installations. From schools and government buildings to private enterprises, our certified
            electricians and technicians are equipped to handle projects of any scale.
          </p>
        </div>
      </ion-item>

      <!-- Why Choose Us -->
      <ion-item lines="none" v-if="!isMobile">
        <div>
          <h1 style="text-align: center; margin-right:25vw;">Why Choose Us</h1>
          <p style="color:#1C8AF7; margin-right:25vw; text-align: center;">
            Our team is made up of BICSI Technicians, RCDDs, and seasoned Master and Journeyman Electricians. With a
            deep commitment to modern standards, safety, and precision, we ensure every project meets the highest level
            of quality and performance.
          </p>
        </div>
        <ion-img :src="bicsiLogo" alt="BICSI Logo" slot="end"
          style="max-width:250px; max-height: auto; width: 40vw; margin-right:10vw;" />

      </ion-item>
      <div v-else>
        <ion-item lines="none">
          <div>
            <h1 style="text-align: center; margin-right:5vw;">Why Choose Us</h1>
            <p style="color:#1C8AF7; margin-right:5vw; text-align: center;">
              Our team is made up of BICSI Technicians, RCDDs, and seasoned Master and Journeyman Electricians. With a
              deep commitment to modern standards, safety, and precision, we ensure every project meets the highest
              level
              of quality and performance.
            </p>
          </div>
          
        </ion-item>

      </div>
      <!-- Services -->
      <ion-item>
        <div>
          <h1>Our Services</h1>
          <p style="color:#1C8AF7; margin-right:20vw">
            We specialize in commercial electrical panel installs, conduit runs, fiber optic termination, access control
            systems, security cameras, fire alarms, and structured cabling for both copper and fiber.
          </p>
        </div>
      </ion-item>

      <!-- Experience & Credibility -->
      <ion-item>
        <div>
          <h1>Decades of Experience You Can Rely On</h1>
          <p style="color:#1C8AF7; margin-right:20vw; text-align: center; ">
            With years of field experience and continuous training in the latest technologies, our experts bring
            unmatched value to every installation. Whether it's conduit work, panel installs, or low voltage
            integration,
            we’ve done it—and done it right.
          </p>
        </div>
      </ion-item>

      <!-- Featured Projects -->
      <ion-item>
        <div>
          <h1>Recent Projects</h1>
          <p style="color:#1C8AF7; margin-right:20vw; text-align: center;">
            We’ve successfully completed installations in airports, schools, warehouses, and government facilities.
            Explore our <b @click="$router.push('/projects')"
              style="color:#0D47A1; cursor: pointer; text-decoration: underline;">Projects</b> page to learn more.
          </p>
        </div>
      </ion-item>

      <!-- Testimonials -->
      <ion-item>
        <div>
          <h1>What Our Clients Say</h1>
          <p style="color:#1C8AF7; margin-right:20vw; text-align: center;">
            "Atlantis Electrical exceeded our expectations with their professionalism and technical expertise."
            <br />– Facilities Manager, Local Government
          </p>
        </div>
      </ion-item>

      <!-- CTA at bottom -->
      <ion-item lines="none">
        <div style="width:100%; display:flex; justify-content:center;">
          <ion-button style="width: 70vw;" class="estimate-cta" expand="block" shape="round" size="large"
            @click="$router.push('/requestquote')">
            Get an Estimate
          </ion-button>
        </div>
      </ion-item>

    </ion-content>
  </ion-page>
</template>

<script setup lang="ts">
import { IonContent, IonPage, IonItem, IonImg, IonButton, } from '@ionic/vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { register } from 'swiper/element/bundle';
register();
import { ref } from 'vue';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/swiper-bundle.css';
import 'swiper/css/scrollbar';
import { mobileBarWidth } from '@/helper';

const bicsiLogo = "https://aes-site-assets.pages.dev/homepage/bicsi.png";
const isMobile = ref(false);
const slides = ref([
  { image: "https://aes-site-assets.pages.dev/logo-resized.png" },
  { image: "https://aes-site-assets.pages.dev/homepage/swiper/image1.jpg", caption: "Melbourne Airport Perimeter Gate Electrical" },
  { image: "https://aes-site-assets.pages.dev/homepage/swiper/image2.jpg", caption: "LC Single Mode Fiber Patching" },
  { image: "https://aes-site-assets.pages.dev/homepage/swiper/image3.jpg", caption: "Meadowlane Primary Elementary Infrastructure Renewal" },
  { image: "https://aes-site-assets.pages.dev/homepage/swiper/image4.jpg", caption: "Meadowlane Primary Elementary Infrastructure Renewal" },
  { image: "https://aes-site-assets.pages.dev/homepage/swiper/image5.jpg", caption: "Wire Management using D-Rings and J-Hooks" },
  { image: "https://aes-site-assets.pages.dev/homepage/swiper/image6.jpg", caption: "110 Punch Block Terminations" },
  { image: "https://aes-site-assets.pages.dev/homepage/swiper/image7.jpg", caption: "Electrical Service Disconnect Installation" },
  { image: "https://aes-site-assets.pages.dev/homepage/swiper/image8.jpg", caption: "South West Middle School Chiller Plant" }
]);

setInterval(() => {
  isMobile.value = window.outerWidth <= mobileBarWidth;
}, 100);
</script>

<style scoped>
.swiper-parent {
  width: 100vw;
  display: flex !important;
  justify-content: center;
  align-items: center;
  background: transparent !important;
  border: none;
}

.responsive-swiper {
  width: 60vw;
  max-width: 900px;
  aspect-ratio: 16/9;
  min-width: 320px;
  min-height: 220px;
  max-height: 500px;
  border-radius: 32px;
  overflow: hidden;
  background: #18191a;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.18);
  margin: 2vh auto 2vh auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.swiper-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  background: #18191a;
}

@media (max-width: 900px) {
  .responsive-swiper {
    width: 90vw;
    height: 32vh;
    min-width: 180px;
    min-height: 120px;
    border-radius: 16px;
  }
}

@media (max-width: 600px) {
  .responsive-swiper {
    width: 98vw;
    height: 24vh;
    min-width: 120px;
    min-height: 80px;
    border-radius: 10px;
  }
}

.slide-caption {
  position: absolute;
  bottom: 12px;
  right: 16px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 6px 10px;
  font-size: 0.9rem;
  border-radius: 4px;
}

.estimate-cta {
  --background: linear-gradient(135deg, #1C8AF7, #0D47A1);
  --background-activated: linear-gradient(135deg, #1565C0, #0A3675);
  --border-radius: 30px;
  margin-top: 30px;
  margin-bottom: 40px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  border-radius: 30px;

}

.estimate-cta:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(24, 124, 242, 0.4);
}

.estimate-cta:active {
  transform: translateY(0);
  box-shadow: 0 4px 8px rgba(24, 124, 242, 0.4);
}
</style>
